import { apiGetUserInfo } from './getUserInfo'

/**
 * 대표 지번 주소 등록 여부 조회 어댑터.
 *
 * mobile-api `GET /user` 의 `address` 또는 `pastAddress` 중 하나라도 값이 있으면 등록으로 판단한다.
 * 유저정보 응답에 '등록 여부' 전용 플래그가 없어 주소 필드 유무로 판단하며,
 * 현재 `address`가 빈 값이어도 과거 주소(`pastAddress`)가 있는 유저가 존재해 두 필드를 함께 본다.
 */
export const apiCheckAddressRegistered = async (): Promise<boolean> => {
  const user = await apiGetUserInfo()
  return Boolean(user.address) || Boolean(user.pastAddress)
}
